export const BB_BETCARD_CSS_CLASS_BLOCK_NAME = 'bb-betcard';

export const BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME = `${BB_BETCARD_CSS_CLASS_BLOCK_NAME}__footer`;
export const BB_BETCARD_FOOTER_CSS_CLASS_FEED = `${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}-feed`;
export const BB_BETCARD_FOOTER_CSS_CLASS_TOP = `${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}-top`;
export const BB_BETCARD_FOOTER_CSS_CLASS_HIGHLIGHT = `${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}-highlight`;

export const BB_BETCARD_FOOTER_ICON_CSS_CLASS_BLOCK_NAME = `${BB_BETCARD_FOOTER_CSS_CLASS_BLOCK_NAME}-icon`;

export const I18N_BETCARD = 'betcard';
export const I18N_BETCARD_MOST_POPULAR = `${I18N_BETCARD}.most_popular`;
export const I18N_BETCARD_MOST_POPULAR_NAME = `${I18N_BETCARD}.most_popular_name`;
export const I18N_BETCARD_LAST_BET = `${I18N_BETCARD}.last_bet_placed`;
export const I18N_BETCARD_STARTS_IN = `${I18N_BETCARD}.starts_in`;

export const BB_BETCARD_TIMEAGO_OPTIONS = [
    'less_then_min', 'less_then_min', 'one_min', 'x_mins', 'one_hour', 'x_hours',
    'one_day', 'x_days', 'one_week', 'x_weeks', 'one_month', 'x_months', 'one_year',
    'x_years',
];

export const BETCARD_WS_HANDLER_COMPONENT_NAME = 'BetcardClassic';
